export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                <i className="ri-plant-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                고흥꿈트리
              </h3>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              전라남도 고흥의 청정 자연 속에서 7개 농가가 함께 만드는 치유마을입니다. 
              자연과 농업의 힘을 통해 몸과 마음의 건강을 회복하는 특별한 경험을 제공합니다.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-green-500 rounded-full flex items-center justify-center transition-colors">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-green-500 rounded-full flex items-center justify-center transition-colors">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-green-500 rounded-full flex items-center justify-center transition-colors">
                <i className="ri-youtube-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">빠른 링크</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-300 hover:text-green-400 transition-colors cursor-pointer"
                >
                  소개
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('partners')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-300 hover:text-green-400 transition-colors cursor-pointer"
                >
                  참여업체
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-300 hover:text-green-400 transition-colors cursor-pointer"
                >
                  치유프로그램
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('reservation')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-300 hover:text-green-400 transition-colors cursor-pointer"
                >
                  예약하기
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6">연락처</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-green-400"></i>
                <span className="text-gray-300 text-sm">전라남도 고흥군</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-green-400"></i>
                <span className="text-gray-300 text-sm">061-830-5000</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-green-400"></i>
                <span className="text-gray-300 text-sm">info@goheung-dreamtree.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-line text-green-400"></i>
                <span className="text-gray-300 text-sm">09:00 - 18:00</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} 고흥꿈트리 협동조합. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-green-400 text-sm transition-colors">
                개인정보처리방침
              </a>
              <a href="#" className="text-gray-400 hover:text-green-400 text-sm transition-colors">
                이용약관
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-green-400 text-sm transition-colors"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}